import { CheckCircleOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { ReactNode } from 'react';

import { TenantStatuses } from 'src/features/tenants/types/tenantList.types';

export const StatusViewByStatus: Record<
  TenantStatuses,
  { Icon: ReactNode; color: string; text: string; toggleAction: string }
> = {
  [TenantStatuses.Active]: {
    Icon: <CheckCircleOutlined />,
    color: 'success',
    text: 'Ativo',
    toggleAction: 'Desativar',
  },
  [TenantStatuses.Inactive]: {
    Icon: <MinusCircleOutlined />,
    color: 'default',
    text: 'Inativo',
    toggleAction: 'Ativar',
  },
};
